import { render, staticRenderFns } from "./FreeMedicalStudents.vue?vue&type=template&id=7ca1c9de&scoped=true"
import script from "./FreeMedicalStudents.vue?vue&type=script&lang=js"
export * from "./FreeMedicalStudents.vue?vue&type=script&lang=js"
import style0 from "./FreeMedicalStudents.vue?vue&type=style&index=0&id=7ca1c9de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca1c9de",
  null
  
)

export default component.exports